export default __webpack_public_path__ + "static/media/reduce-size.1235f385.svg";